import IdleJs from 'idle-js';
import store from "../store";
import { Activity } from "../services/api/user-activity";

export const getIdleConfig = (idleTime, statusChangeCallback) => ({
    idle: idleTime,
    events: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'touchmove'],
    onIdle: () => {
        if (store.state.activity.activity.status === 'online') {
            statusChangeCallback('offline');
            Activity.changeStatus('offline').catch(error => {
                console.error("Error changing activity to inactive:", error);
            });
        }
    },
    onActive: () => {
        if (store.state.activity.activity.status === 'offline') {
            statusChangeCallback('online');
            Activity.changeStatus('online').catch(error => {
                console.error("Error changing activity to active:", error);
            });
        }
    },
    onShow: () => {
        if (store.state.activity.activity.status === 'offline') {
            statusChangeCallback('online');
            Activity.changeStatus('online').catch(error => {
                console.error("Error changing activity to active:", error);
            });
        }
    },
    keepTracking: true,
    startAtIdle: false,
});

export const initializeIdle = (config) => new IdleJs(config);